import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { type HandOffActionWidgetStore } from 'pages/chatbot/ui/UnifiedAgent/ui/InstructionsSection/ui/HandOffActionWidget/store/handOffActionWidgetStore.ts'
import { useWidgetKeyboard } from 'pages/chatbot/ui/UnifiedAgent/hooks/useWidgetKeyboard.ts'
import { ActionsStep4 } from 'pages/chatbot/ui/UnifiedAgent/ui/InstructionsSection/ui/Steps/ActionsStep4.tsx'
import { fnKey } from 'pages/chatbot/ui/UnifiedAgent/lib/getLastStepHintMessage.ts'

export const HandoffTriggerStep = observer(({ store }: { store: HandOffActionWidgetStore }) => {
  const { setHint } = store
  useWidgetKeyboard({
    onNext: store.onSubmit,
    onEscape: store.handleClose,
  })
  useEffect(() => {
    setHint([`${fnKey}Enter to submit`, 'Esc to skip'])
    return () => {
      setHint([])
    }
  }, [])
  return <ActionsStep4 value={store.triggerText} onChange={store.setTriggerText} />
})
